import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  DEFAULT_ORG_TIMEZONE,
  formatOrgDate,
  type OrgDateFormat,
  type FormatOrgDateOptions,
} from '@vipso/shared';
import type { RootState } from '../store';

export type DateFormat = OrgDateFormat;
export type FormatDateOptions = FormatOrgDateOptions;

export function useDate() {
  const orgTimezone = useSelector((state: RootState) => {
    const tz = state.auth.org?.timezone;
    return typeof tz === 'string' && tz.trim() ? tz.trim() : null;
  });

  const timeZone = orgTimezone || DEFAULT_ORG_TIMEZONE;

  const format = useCallback(
    (
      value: string | Date | number | null | undefined,
      formatOrOptions: DateFormat | FormatDateOptions = 'date',
    ) => formatOrgDate(value, timeZone, formatOrOptions),
    [timeZone],
  );

  return useMemo(() => ({ format, timeZone }), [format, timeZone]);
}
